module.exports = __webpack_public_path__ + "static/img/uav-1.92c6af64.png";